import axios from "axios";
import {
  baseApiUrl,
  getHttpHeaders,
  httpRequest,
  getHttpHeadersPowerPoint,
} from "./ApiUtils";

const contractProposalApiUrl = `${baseApiUrl}/api/ContractProposal`;

export async function getContractProposalList(
  name,
  managerName,
  orderBy,
  contractTypeId,
  carrearLevelId,
  month,
  year,
) {
  return await httpRequest(
    fetchContractProposals.bind(
      this,
      name,
      managerName,
      orderBy,
      contractTypeId,
      carrearLevelId,
      month,
      year
    )
  );
}
async function fetchContractProposals(
  name,
  managerName,
  orderBy,
  contractTypeId,
  carrearLevelId,
  month,
  year,
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${contractProposalApiUrl}?Name=${name}&ManagerName=${managerName}&OrderBy=${orderBy}&ContractTypeId=${contractTypeId}&CarrearLevelId=${carrearLevelId}&Month=${month}&Year=${year}`,
    config
  );
}

export async function getContractTypeCounters(month, year) {
  return await httpRequest(fetchContractTypeCounters.bind(this, month, year));
}
async function fetchContractTypeCounters(month, year) {
  let config = getHttpHeaders();
  return await axios.get(`${contractProposalApiUrl}/ContractTypes/Counters?Month=${month}&Year=${year}`, config);
}

export async function getContractProposalById(id) {
  return await httpRequest(fetchContractProposalById.bind(this, id));
}
async function fetchContractProposalById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${contractProposalApiUrl}/${id}`, config);
}

export async function getContractProposalsStatistics(month, year) {
  return await httpRequest(fetchContractProposalsStatistics.bind(this, month, year));
}
async function fetchContractProposalsStatistics(month, year) {
  let config = getHttpHeaders();
  return await axios.get(`${contractProposalApiUrl}/Statistics?Month=${month}&Year=${year}`, config);
}

export async function addContractProposal(contractproposal) {
  return await httpRequest(postContractProposal.bind(this, contractproposal));
}

async function postContractProposal(contractproposal) {
  let config = getHttpHeaders();
  return await axios.post(
    `${contractProposalApiUrl}`,
    contractproposal,
    config
  );
}

export async function updateContractProposal(contractproposal) {
  return await httpRequest(putContractproposal.bind(this, contractproposal));
}

async function putContractproposal(contractproposal) {
  let config = getHttpHeaders();
  return await axios.put(`${contractProposalApiUrl}`, contractproposal, config);
}

export async function deleteContractProposal(id) {
  return await httpRequest(fetchDeleteContractproposal.bind(this, id));
}

async function fetchDeleteContractproposal(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${contractProposalApiUrl}/${id}`, config);
}

export async function generateContractProposalPWP(id, lang) {
  return await httpRequest(fetchContractProposalGeneratePWP.bind(this, id, lang));
}

async function fetchContractProposalGeneratePWP(id, lang) {
  let config = getHttpHeadersPowerPoint();
  return await axios.get(
    `${contractProposalApiUrl}/GenerateContractProposalPWP?id=${id}&lang=${lang}`,
    config
  );
}
